import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TariffRateService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Get Tariff Rate.
   * @param tariffRateRequest Tariff Rate Request
   */
  getTariffRate(tariffRateRequest: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/tariffRate`;
    return this.http.post(url, tariffRateRequest);
  }

  /**
   * Get Tariff Rate by Seq No.
   * @param seqNo Seq No
   */
  getTariffRateDetail(seqNo: any): Promise<any> {
    const url = `${environment.expenseApiUrl}/tariffRate/${seqNo}`;
    return this.http.get(url).toPromise();
  }

  /**
   * add Tariff Rate
   */
  addTariffRate(saveObj: any): Observable<any>{
    const url = `${environment.expenseApiUrl}/tariffRate/add`;
    return this.http.post(url, saveObj);
  }

  /**
   * update Tariff Rate
   */
  updateTariffRate(updateObj: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/tariffRate/update`;
    return this.http.put(url, updateObj);
  }

  /**
   * import Tariff Rate by excel
   * @param file upload file
   * @param createUser create User
   */
   importTariffRateByExcel(file: any, facility: any, createUser: any): Observable<any>{
    const url = `${environment.expenseApiUrl}/import/tariffRateExcelBy/`;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('facility', facility);
    formData.append('createUser', createUser);

    let response = this.http.post(url, formData);
    return response;
  }
}
